import { Location } from 'history'
import React from 'react'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import SvgToolbarDownload from 'src/components/Svgs/SvgToolbarDownload'
import { LocationState } from 'src/redux/createRootReducer'

export interface UtilityToolbarDownloadProps {
  onClick?: () => void
  to?: Location<LocationState> | string
  disabled?: boolean
  loading?: boolean
}

const UtilityToolbarDownload: React.FC<UtilityToolbarDownloadProps> = ({
  disabled,
  loading,
  onClick,
  to,
}): React.ReactElement => {
  return (
    <HoverableLink
      ariaLabelSource={'Download'}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      to={to}
      testId="downloadOptionsBtn"
    >
      <SvgToolbarDownload />
    </HoverableLink>
  )
}

export default UtilityToolbarDownload
